import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';
import "../css/BlueTile.css"; // External CSS

const BlueTile = ({ title, subtitle, imageSrc, containerStyles = {}, imageStyles = {}, agentData = {}, isLoading = false, bucketName }) => {
  
  // Extract data from the API response
  const {
    name,
    system_ai_agent,
    organization,
    created_at,
    updated_at
  } = agentData || {};

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <Box className="blue-tile" sx={{ ...containerStyles }}>
      {/* Left Side: Content */}
      <Box className="text-container" sx={{ flex: 1 }}>
        {/* Agent Name */}
        {isLoading ? (
          <Skeleton variant="text" width="60%" height={25} sx={{ mb: 1 }} />
        ) : (
          <h2 variant="h6" className="tile-title">
            {name || title}
          </h2>
        )}
        
        {/* Agent Details */}
        <Box sx={{ mb: 1 }}>
          {isLoading ? (
            <>
              <Skeleton variant="text" width="80%" height={20} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="70%" height={20} sx={{ mb: 0.5 }} />
            </>
          ) : (
            <>
              {system_ai_agent?.name && (
                <Typography variant="body2" className="tile-subtitle" sx={{ mb: 0.5, opacity: 0.9 }}>
                  System AI Agent: {system_ai_agent.name}
                </Typography>
              )}
              {organization?.name && (
                <Typography variant="body2" className="tile-subtitle" sx={{ mb: 0.5, opacity: 0.9 }}>
                  Organization: {organization.name}
                </Typography>
              )}
              
              {/* Bucket Name Badge - positioned right after agent details */}
              {bucketName && (
                <Box sx={{ 
                  display: 'inline-block',
                  mt: 1
                }}>
                  <Box sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.5,
                    px: 1.5,
                    py: 0.5,
                    backgroundColor: 'rgba(34, 197, 94, 0.1)',
                    border: '1px solid rgba(34, 197, 94, 0.3)',
                    borderRadius: '12px',
                    color: '#16a34a',
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    '&:hover': {
                      backgroundColor: 'rgba(34, 197, 94, 0.15)',
                      borderColor: 'rgba(34, 197, 94, 0.4)',
                    },
                    transition: 'all 0.2s ease'
                  }}>
                    <Box sx={{
                      width: 6,
                      height: 6,
                      borderRadius: '50%',
                      backgroundColor: '#16a34a',
                      flexShrink: 0
                    }} />
                    Bucket: {bucketName}
                  </Box>
                </Box>
              )}
                      {/* Dates */}
            {(created_at || updated_at) && (
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                {created_at && (
                  <Typography variant="body2" className="tile-subtitle" sx={{ fontSize: '0.7rem', opacity: 0.7 }}>
                    Created: {formatDate(created_at)}
                  </Typography>
                )}
                {updated_at && (
                  <Typography variant="body2" className="tile-subtitle" sx={{ fontSize: '0.7rem', opacity: 0.7 }}>
                    Updated: {formatDate(updated_at)}
                  </Typography>
                )}
              </Box>
            )}
            </>
          )}
        </Box>

        {/* Bucket Name and Dates Row */}
        {isLoading ? (
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2, 
            flexWrap: 'wrap',
            mt: 1
          }}>
            <Skeleton variant="text" width="120px" height={16} />
            <Skeleton variant="text" width="100px" height={16} />
          </Box>
        ) : (
          (bucketName || created_at || updated_at) && (
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2, 
            flexWrap: 'wrap',
            mt: 1
          }}>
          
            
    
          </Box>
        )
        )}



        {/* Fallback subtitle if no agent data */}
        {!isLoading && !name && subtitle && (
          <Typography variant="body2" className="tile-subtitle">
            {subtitle}
          </Typography>
        )}
      </Box>

      {/* Right Side: Image */}
      <Box className="image-container" sx={{ ...imageStyles }}>
        {isLoading ? (
          <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: '8px' }} />
        ) : (
          <img src={imageSrc} alt="Tile" className="main-image" />
        )}
      </Box>
    </Box>
  );
};

export default BlueTile;
